import Usuario from "model/administracao/cadastro/Usuario";
import DocumentoPastaAcao from "./DocumentoPastaAcao";

export default class DocumentoPastaAcessoUsuario {
    usuario: Usuario; 
    acoes: DocumentoPastaAcao[];

    constructor(usuario: Usuario, acoes: DocumentoPastaAcao[]) {
        this.usuario = usuario;
        this.acoes = acoes;
    }
}